function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/interopRequireDefault.js
// module id = 6
// module chunks = 168707334958949